import React from "react";
import { Link } from "react-router-dom";

// The lockup: the supplied ball mark plus a two-tone wordmark. Sits around
// 150–170px wide in the header (§13) — the mark itself is never oversized.
const Logo = ({ to = "/", size = "md", inverted = false, className = "" }) => {
  const mark = size === "sm" ? "h-7 w-7" : size === "lg" ? "h-10 w-10" : "h-9 w-9";
  const text = size === "sm" ? "text-lg" : size === "lg" ? "text-2xl" : "text-xl";

  const inner = (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <img
        src={`${process.env.PUBLIC_URL}/padelrank-logo.svg`}
        alt=""
        className={`${mark} shrink-0`}
        aria-hidden="true"
      />
      <span className={`${text} font-bold tracking-tight`}>
        <span className={inverted ? "text-white" : "text-navy"}>Padel</span>
        <span className={inverted ? "text-primary-hover" : "text-primary"}>
          Rank
        </span>
      </span>
    </span>
  );

  if (!to) return inner;
  return (
    <Link to={to} aria-label="PadelRank home" className="shrink-0">
      {inner}
    </Link>
  );
};

export default Logo;
